export default {
  name: 'home',
  components: {
  },
  data () {
    return {
      input: ''
    }
  },
  methods: {
  },
  // 计算属性
  computed: {
  },
  created () {
  },
}



// WEBPACK FOOTER //
// ./src/views/custom/home/script.js